import { useEffect, useState } from 'react';
import Select from 'react-select';
import { IoCloseSharp } from 'react-icons/io5';

import {
  ItemRow,
  ItemInput,
  SelectWrapper,
  InfoLabel,
  RemoveIcon
} from './update-order.item.styles';

const UpdateOrderItem = ({ orderItem, inventories, updateOrderItem, onRemove }) => {
  const [selectedInventoryId, setSelectedInventoryId] = useState(
    orderItem?.inventoryId?.toString() ?? ''
  );
  const [quantity, setQuantity] = useState(orderItem?.quantity ?? 1);
  const [unitPrice, setUnitPrice] = useState(orderItem?.unitPrice ?? 0);

  const selectedInventory = inventories.find(
    (inv) => inv.id.toString() === selectedInventoryId
  );

  const inventoryExists = !!selectedInventory;

  const fallbackLabel = orderItem?.inventory?.Product?.name
    ? `${orderItem.inventory.Product.name} (${orderItem.inventory.Product.type}) - ${orderItem.inventory.size}`
    : `Missing Inventory (ID: ${selectedInventoryId})`;

  useEffect(() => {
    if (selectedInventory?.price != null) {
      setUnitPrice(selectedInventory.price);
    }
  }, [selectedInventoryId]);

  useEffect(() => {
    if (updateOrderItem) {
      updateOrderItem({
        ...orderItem,
        inventoryId: parseInt(selectedInventoryId),
        quantity,
        unitPrice
      });
    }
  }, [selectedInventoryId, quantity, unitPrice]);

  const inventoryOptions = [
    {
      label: '-- Select New Inventory --',
      value: '',
      isDisabled: true
    },
    ...inventories.map((inv) => ({
      value: inv.id.toString(),
      label: `${inv.Product?.name ?? 'Unknown'} - ${inv.size} - ${inv.sizeDescription} (${inv.type})`
    }))
  ];

  const selectedOption =
    inventoryOptions.find(opt => opt.value === selectedInventoryId) ||
    (!inventoryExists && {
      value: selectedInventoryId,
      label: fallbackLabel
    }) ||
    inventoryOptions[0];

  return (
    <ItemRow>
      <InfoLabel>
        {selectedInventory?.Product?.name ??
          orderItem?.inventory?.Product?.name ??
          'Unknown Product'}
      </InfoLabel>

      <SelectWrapper>
        <Select
          options={inventoryOptions}
          value={selectedOption}
          onChange={(selected) => setSelectedInventoryId(selected?.value || '')}
          placeholder="-- Select Inventory --"
        />
      </SelectWrapper>

      <ItemInput
        type="number"
        min="1"
        value={quantity}
        onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
        placeholder="Quantity"
        width="60px"
      />

      <ItemInput
        type="number"
        min="0"
        value={unitPrice}
        onChange={(e) => setUnitPrice(parseInt(e.target.value) || 0)}
        placeholder="Unit Price"
        width="100px"
      />

      <InfoLabel>
        <strong>Total:</strong> ${(quantity * unitPrice / 100).toFixed(2)}
      </InfoLabel>

      {onRemove && (
        <RemoveIcon>
          <IoCloseSharp onClick={onRemove} />
        </RemoveIcon>
      )}
    </ItemRow>
  );
};

export default UpdateOrderItem;